import React from "react";
import { INSURERS } from "@/lib/content";

const Insurers = () => {
  return (
    <section
      id="aseguradoras"
      data-testid="insurers-section"
      className="relative bg-[#F9F6F0] text-[#0B0410] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#3D1565]" />
            <span
              className="text-[11px] tracking-luxury uppercase text-[#3D1565] font-semibold"
              data-testid="insurers-eyebrow"
            >
              Aseguradoras
            </span>
          </div>
          <h2
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08] text-[#0B0410]"
            data-testid="insurers-headline"
          >
            Comparamos para elegir{" "}
            <span className="italic text-[#3D1565]">lo correcto</span>.
          </h2>
          <p className="mt-6 text-base lg:text-lg text-[#0B0410]/70 font-light">
            Trabajamos con las principales aseguradoras reguladas en México y
            en sus países de origen — vida, gastos médicos mayores, salud
            internacional, auto y patrimonial.
          </p>
        </div>

        <div
          data-testid="insurers-grid"
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 border-t border-l hairline-dark"
        >
          {INSURERS.map((ins) => (
            <div
              key={ins.name}
              data-testid={`insurer-${ins.name.replace(/\s+/g, "-").toLowerCase()}`}
              className="border-r border-b hairline-dark aspect-[5/3] flex items-center justify-center p-6 bg-white hover:bg-[#0B0410] transition-colors duration-500 group"
            >
              <span className="font-display text-2xl sm:text-3xl text-[#0B0410] group-hover:text-[#E6D5B8] tracking-tight transition-colors duration-500 text-center font-light">
                {ins.wordmark}
              </span>
            </div>
          ))}
        </div>

        <p className="mt-10 text-xs text-[#0B0410]/55 max-w-3xl">
          Todas las instituciones aquí mencionadas se encuentran reguladas por
          las autoridades financieras de México y/o sus países de origen. La
          contratación de productos siempre se realiza directamente con la
          institución correspondiente.
        </p>
      </div>
    </section>
  );
};

export default Insurers;
